import { settingsApi } from '@/api';
import { ErrorNotificationIcon } from '@/assets/icons';
import { useToast } from '@/store/useToast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useGetInvoice = () => {
    const queryClient = useQueryClient();

    const showToast = useToast((state) => state.show);

    const mutation = useMutation({
        mutationFn: settingsApi.getInvoice,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profiles'] });
        },
        onError: (error) => {
            console.error('Error complain profile:', error);
            showToast({
                // type error
                icon: <ErrorNotificationIcon />,
                msg: 'Ошибка отправки заявки'
            });
        },
    });

    return mutation;
};
